import { ApiError, apiPost } from '@services/apiClient'

/**
 * POST /api/auth/verify-email — register 時メールリンクのトークン消費 (T-H2)。
 *
 * `authedFetch` ではなく素の `apiPost` 経由: 未認証でも (ログアウト後でも) 叩ける必要があり、
 * cookie 等は不要。
 */
export const verifyEmail = async (token: string): Promise<void> => {
  await apiPost<{ ok: true }, { token: string }>('/auth/verify-email', { token })
}

export { ApiError }
